const devices = {
  phone: `(min-width: 300px)`,
  tablet: `(min-width: 768px)`,
  desktop: `(min-width: 1024px)`,
  monitor: `(min-width: 2560px)`
};

export default devices;
